import { render, staticRenderFns } from "./classHours.vue?vue&type=template&id=551aca97&scoped=true"
import script from "./classHours.vue?vue&type=script&lang=js"
export * from "./classHours.vue?vue&type=script&lang=js"
import style0 from "./classHours.vue?vue&type=style&index=0&id=551aca97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551aca97",
  null
  
)

export default component.exports